import React, { createContext, useState, useContext } from "react";

interface SessionTimerContextProps {
  sessionTimer: Date;
  setSessionTimer: React.Dispatch<React.SetStateAction<Date>>;
  resetSessionTimer: () => void;
  timerDuration: number;
  setTimerDuration: React.Dispatch<React.SetStateAction<number>>;
}

const SessionTimerContext = createContext(null);

export const useSessionTimer = (): SessionTimerContextProps => {
  return useContext(SessionTimerContext as any);
};

export const SessionTimerProvider = ({ children }: any) => {
  const [sessionTimer, setSessionTimer] = useState(new Date());
  const [timerDuration, setTimerDuration] = useState(30);

  const resetSessionTimer = () => {
    setSessionTimer(new Date());
    setTimerDuration(30);
  };

  const value = {
    sessionTimer,
    setSessionTimer,
    resetSessionTimer,
    timerDuration,
    setTimerDuration,
  };

  return (
    <SessionTimerContext.Provider value={value}>
      {children}
    </SessionTimerContext.Provider>
  );
};
